// plan-refuerzo-seguimiento.component.ts
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { PlanRefuerzoComportamientoService } from "../../../../../shared/services/plan-refuerzo-comportamiento.service";
import { SeguimientoPlanRefuerzoService } from "../../../../../shared/services/seguimientoPlanRefuerzoComportamiento.service";
import { PropietarioService } from "../../../../../shared/services/propietarios.service";
import { EstadoPlanAccionService, EstadoPlanAccion } from "../../../../../shared/services/estado-plan-accion.service";
import { Utils } from "../../../../../shared/utils/Utils";
import { SeguimientoFormModalComponent } from "../seguimiento-form-modal/seguimiento-form-modal.component";
import { AccionRefuerzoFormModalComponent } from "../accion-refuerzo-form-modal/accion-refuerzo-form-modal.component";

@Component({
  selector: "app-plan-refuerzo-seguimiento",
  templateUrl: "./plan-refuerzo-seguimiento.component.html",
  styleUrls: ["./plan-refuerzo-seguimiento.component.scss"],
})
export class PlanRefuerzoSeguimientoComponent implements OnInit {
  @Input() idEvaluacion!: number;
  @Input() nombreColaborador = "";

  cargando = false;
  cargandoSeguimientoPorAccion: Record<number, boolean> = {};

  acciones: any[] = [];
  seguimientosPorAccion: Record<number, any[]> = {};
  accionExpandida: number | null = null;

  colaboradores: any[] = [];
  cargandoColaboradores = false;

  estadosPlan: EstadoPlanAccion[] = [];

  paginaPorAccion: Record<number, number> = {};
  pageSizePorAccion: Record<number, number> = {};
  readonly PAGE_SIZE_DEFAULT = 5;

  readonly Number = Number;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private planRefuerzoService: PlanRefuerzoComportamientoService,
    private seguimientoService: SeguimientoPlanRefuerzoService,
    private propietarioService: PropietarioService,
    private estadoPlanAccionService: EstadoPlanAccionService,
  ) {}

  ngOnInit(): void {
    this.cargarColaboradores();
    this.cargarEstadosPlan();
    this.cargarAcciones();
  }

  private cargarColaboradores(): void {
    this.cargandoColaboradores = true;
    this.propietarioService.getPlanAccion().subscribe({
      next: (response: any) => {
        const lista = Array.isArray(response) ? response : response?.data || [];
        this.colaboradores = lista.map((c: any) => ({
          ...c,
          cedula: c?.cedula != null ? String(c.cedula).trim() : c?.cedula,
        }));
        this.cargandoColaboradores = false;
      },
      error: () => {
        this.colaboradores = [];
        this.cargandoColaboradores = false;
      },
    });
  }

  cargarAcciones(): void {
    if (!this.idEvaluacion) return;
    this.cargando = true;
    this.planRefuerzoService.getAllByEvaluacion(this.idEvaluacion).subscribe({
      next: (response: any) => {
        const lista = Array.isArray(response) ? response : response?.data || [];
        this.acciones = lista.filter((a: any) => Number(a.estado) === 1);
        this.cargando = false;
      },
      error: () => {
        this.acciones = [];
        this.cargando = false;
        Swal.fire("Error", "No se pudo cargar el plan de refuerzo.", "error");
      },
    });
  }

  private cargarEstadosPlan(): void {
    this.estadoPlanAccionService.getEstados().subscribe({
      next: (response: any) => {
        this.estadosPlan = Array.isArray(response) ? response : response?.data || [];
      },
      error: () => {
        this.estadosPlan = [];
      },
    });
  }

  /** Descripción legible del estado del plan (PENDIENTE, EN PROGRESO, etc.) */
  descripcionEstadoPlan(idEstadoPlan: any): string {
    const estado = this.estadosPlan.find((e) => Number(e.id) === Number(idEstadoPlan));
    return estado?.descripcion || "SIN ESTADO";
  }

  /** Color del badge según el estado del plan (mapeado por convención del catálogo) */
  claseEstadoPlan(idEstadoPlan: any): string {
    switch (Number(idEstadoPlan)) {
      case 1:
        return "bg-warning text-dark"; // Pendiente
      case 2:
        return "bg-info text-dark"; // En progreso
      case 3:
        return "bg-success"; // Completado
      case 4:
        return "bg-danger"; // Vencido
      default:
        return "bg-secondary";
    }
  }

  toggleAccion(accion: any): void {
    const id = Number(accion.id);
    this.accionExpandida = this.accionExpandida === id ? null : id;

    if (this.accionExpandida === id) {
      this.paginaPorAccion[id] = this.paginaPorAccion[id] || 1;
      this.pageSizePorAccion[id] = this.pageSizePorAccion[id] || this.PAGE_SIZE_DEFAULT;
      if (!this.seguimientosPorAccion[id]) {
        this.cargarSeguimientos(id);
      }
    }
  }

  cargarSeguimientos(idAccion: number): void {
    this.cargandoSeguimientoPorAccion[idAccion] = true;
    this.seguimientoService.getByAccion(idAccion).subscribe({
      next: (response: any) => {
        const lista = Array.isArray(response) ? response : response?.data || [];
        this.seguimientosPorAccion[idAccion] = lista;
        this.cargandoSeguimientoPorAccion[idAccion] = false;
      },
      error: () => {
        this.seguimientosPorAccion[idAccion] = [];
        this.cargandoSeguimientoPorAccion[idAccion] = false;
      },
    });
  }

  // ============ MODAL EDITAR ACCIÓN DE REFUERZO ============

  abrirModalAccion(accion: any, event: Event): void {
    event.stopPropagation();

    const modalRef = this.modalService.open(AccionRefuerzoFormModalComponent, {
      backdrop: "static",
      size: "lg",
    });

    modalRef.componentInstance.accion = accion;
    modalRef.componentInstance.colaboradores = this.colaboradores;
    modalRef.componentInstance.cargandoColaboradores = this.cargandoColaboradores;

    modalRef.result.then(
      (guardado) => {
        if (guardado) {
          this.cargarAcciones();
        }
      },
      () => {
        // modal descartado, no se requiere acción
      },
    );
  }

  // ============ MODAL CREAR / EDITAR SEGUIMIENTO ============

  abrirModalSeguimiento(accion: any, seguimiento: any = null): void {
    const modalRef = this.modalService.open(SeguimientoFormModalComponent, {
      backdrop: "static",
      size: "lg",
    });

    modalRef.componentInstance.idAccionRefuerzo = Number(accion.id);
    modalRef.componentInstance.seguimiento = seguimiento;
    modalRef.componentInstance.colaboradores = this.colaboradores;
    modalRef.componentInstance.cargandoColaboradores = this.cargandoColaboradores;

    modalRef.result.then(
      (guardado) => {
        if (guardado) {
          this.cargarSeguimientos(Number(accion.id));
          this.cargarAcciones();
        }
      },
      () => {
        // modal descartado, no se requiere acción
      },
    );
  }

  inactivarSeguimiento(idAccion: number, seguimiento: any): void {
    Swal.fire({
      title: "¿Inactivar este seguimiento?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      this.seguimientoService.inactivar(Number(seguimiento.id)).subscribe({
        next: () => {
          Swal.fire("Éxito", "Seguimiento inactivado.", "success");
          this.cargarSeguimientos(idAccion);
          this.cargarAcciones();
        },
        error: () => Swal.fire("Error", "No se pudo inactivar el seguimiento.", "error"),
      });
    });
  }

  activarSeguimiento(idAccion: number, seguimiento: any): void {
    Swal.fire({
      title: "¿Activar este seguimiento?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, activar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      this.seguimientoService.activar(Number(seguimiento.id)).subscribe({
        next: () => {
          Swal.fire("Éxito", "Seguimiento activado.", "success");
          this.cargarSeguimientos(idAccion);
          this.cargarAcciones();
        },
        error: () => Swal.fire("Error", "No se pudo activar el seguimiento.", "error"),
      });
    });
  }

  // ============ EXPORTAR ============

  tablaSeguimientoId(idAccion: number): string {
    return `tblSeguimiento_${idAccion}`;
  }

  exportarExcel(idAccion: number): void {
    Utils.exportVisibleTableToExcel(this.tablaSeguimientoId(idAccion), `seguimiento_accion_${idAccion}`);
  }

  exportarPDF(idAccion: number): void {
    Utils.exportToPDF(
      this.tablaSeguimientoId(idAccion),
      `seguimiento_accion_${idAccion}`,
      "Seguimiento plan de refuerzo",
      true,
    );
  }

  cerrar(): void {
    this.activeModal.close();
  }
}